/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Appointment = 1, Gap = 2, Travel = 3
 */
export enum Routemize_DTOs_TimelineItemType {
    APPOINTMENT = 'Appointment',
    GAP = 'Gap',
    TRAVEL = 'Travel',
}
